// extracted by mini-css-extract-plugin
export default {"container":"LeftPanel_container__eFEVm"};